import { LeaseBase } from './base/lease-base';

export class Lease extends LeaseBase { }